if ( typeof customElements.get('read-more-text') == 'undefined' ) {
	customElements.define('read-more-text', class ReadMoreText extends HTMLElement {
		connectedCallback() {
			this.content = this.querySelector('.read-more-text__content');
			this.toggle = this.querySelector('.read-more-text__toggle');
			this.toggle.addEventListener('click', () => {
				const expanded = this.classList.toggle('read-more-text--expanded');
				this.toggle.setAttribute('aria-expanded', expanded);
				this.toggle.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
			});
			new ResizeObserver(() => this.update()).observe(this.content);
		}
		update() {
			if ( this.classList.contains('read-more-text--expanded') ) return;
			this.toggle.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
		}
	});
}
